import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LetterRequestCustomer_Review } from 'src/app/Interface/LetterRequestCustomer_Review';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LetterrequestcustomerEvaluateService {

  constructor(private http: HttpClient) { }

  GetRecord(Token: String): Observable<Array<LetterRequestCustomer_Review>> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerEvaluate?token=" + Token).pipe(
      map(data => {
        return data as Array<LetterRequestCustomer_Review>
      })
    )
  }

  GetActiveList(Token:String,id:number):Observable<Array<LetterRequestCustomer_Review>>{
    return this.http.get(environment.BaseUrl + "Daro/LetterrequestcustomerEvaluate/GetActiveList?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Array<LetterRequestCustomer_Review>
      })
    )
  }

  AddEdit(model:LetterRequestCustomer_Review,
    option: Array<string>,
    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id: model.id,
      type:model.type ,
      title: model.title,
      token: Token,
      option: option,
    }

    return this.http.post(environment.BaseUrl + "Daro/LetterrequestcustomerEvaluate/AddEdit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  SubmitEvalute(model: Array<LetterRequestCustomer_Review>,Token:String,id:number):Observable<LetterRequestCustomer_Review>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_Model = []
    for (let item of model)
    {
      Local_Model.push({
        review_id:item.id,
        answer:item.dsc,
      })
    }

    var body = {
      id:Number(id),
      token:Token,
      model:Local_Model
    }


    console.log(body);


      return this.http.post(environment.BaseUrl + "Daro/LetterrequestcustomerEvaluate/SubmitEvalute",body,{headers}).pipe(
        map(data=>{
          return data as LetterRequestCustomer_Review
        })
      )

  }

  Delete(Token: String,id:number): Observable<Array<LetterRequestCustomer_Review>> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerEvaluate/Delete?token=" + Token + "&id="+id).pipe(
      map(data => {
        return data as Array<LetterRequestCustomer_Review>
      })
    )
  }

}
